import Icon from '@/shared/components/base/Icon/Icon.vue';
import { Plugin } from 'vue';
// import LogoIcon from '@/assets/icons/logo.svg?icon';

export const GlobalComponentsPlugin = {
  install(app) {
    // eslint-disable-next-line vue/multi-word-component-names
    app.component('Icon', Icon);
  },
} as Plugin;

